import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormDefinition, FormSubscription } from 'app/shared/models/class/forms/form-definition';
import { Notice } from 'app/shared/models/class/notice/notice';
import { ArticlePlaceService } from 'app/shared/services/articlePlace/article-place.service';
import { FormService } from 'app/shared/services/forms/form.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserAdminService } from 'app/shared/services/user-admin/user-admin.service';

export interface DialogData {
  title: string;
  text: string;
  action: string;
  id: any;
  block?: any;
  file?: any;
  notice?: Notice;
  form?: FormDefinition;
}

@Component({
  selector: 'app-open-dialog-delete-element',
  templateUrl: './open-dialog-delete-element.component.html',
  styleUrls: ['./open-dialog-delete-element.component.scss'],

})
export class OpenDialogDeleteElementComponent {

  isConfirm = false;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogDeleteElementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly offerService: OfferService,
    private readonly practicePlaceService: PracticePlaceService,
    private readonly userAdminService: UserAdminService,
    private readonly noticeService: NoticeService,
    private readonly uiService: UiService,
    private readonly articlePlaceService: ArticlePlaceService,
    private readonly formService: FormService

  ) {}

  confirmAction(): void {

    switch (this.data.action) {
      case 'exceedPlaceFree':
        this.dialogRef.close();
        break;

      case 'deleteOffer':
        this.offerService.deleteOffer(this.data.id).subscribe({
          next: () => { this.dialogRef.close(); }
        });
        break;
      case 'deletePracticePlace':
        this.practicePlaceService.deletePracticePlaceByClub(this.data.id).subscribe({
          next: () => { this.dialogRef.close(); }
        });
        break;

      case 'deleteUserAdmin':
        this.userAdminService.delete(this.data.id).subscribe({
          next: () => {
            this.uiService.showSnackbar(`L'utilisateur a été supprimé avec succès.`);
            this.dialogRef.close(true);
          }
        });
        break;

      case 'deleteNotice':
        this.noticeService.delete(this.data.id).subscribe({
          next: () => {
            this.uiService.showSnackbar(`L'annonce a été supprimée avec succès.`);
            this.dialogRef.close(true);
          }
        });
        break;

      case 'deleteFormDefinition':
        this.formService.deleteFormDefinition(this.data.id).subscribe({
          next: () => {
            this.uiService.showSnackbar(`Le formulaire a été supprimé avec succès.`);
            this.dialogRef.close(true);
          }
        });
        break;

      case 'deleteSubscription':
        this.formService.deleteFormSubscription(this.data.id).subscribe({
          next: () => {
            this.uiService.showSnackbar(`La souscription a été supprimée avec succès.`);
            this.dialogRef.close(true);
          }
        });
        break;

      case 'activateOrDeactivateFD':
        {
          let formDefinition = this.data.form!;

          const fdToSend: FormDefinition = {
            key: formDefinition.key,
            enabled: !formDefinition.enabled,
            name: formDefinition.name,
            description: formDefinition.description,
            actors: formDefinition.actors,
            fields: formDefinition.fields
          };
          this.formService.putFormDefinition(fdToSend).subscribe({
            next: () => {
              this.uiService.showSnackbar(`Le formulaire a été ${formDefinition.enabled ? 'désactivé' : 'activé'} avec succès.`);
              this.dialogRef.close(true);
            },
            error: () => {
              this.uiService.showSnackbar(`Une erreur est survenue durant la modification.`);
              this.dialogRef.close(false);
            }
          });
          break;
        }

      case 'updateTopText':
        this.noticeService.putTopNotice(this.data.block, this.data.file).subscribe({
          next: () => {
            this.uiService.showSnackbar(`Le texte a été modifié avec succès.`);
            this.dialogRef.close(true);
          },
          error: () => {
            this.uiService.showSnackbar(`Une erreur est survenue durant l'édition.`);
            this.dialogRef.close(false);
          }
        });
        break;

      case 'updateNotice':
        if (this.data.notice) {
          this.data.notice.thumbImage = "";
        }
        this.noticeService.putNotice(this.data.notice!).subscribe({
          next: () => {
            this.uiService.showSnackbar(`L'image a été supprimée avec succès.`);
            this.dialogRef.close(true);
          },
          error: () => {
            this.uiService.showSnackbar(`Une erreur est survenue durant la suppression.`);
            this.dialogRef.close(false);
          }
        })
        break;

      case 'initPassword':
        this.userAdminService.resetPassword(this.data.id!).subscribe({
          next: () => { this.dialogRef.close(); }
        });
        break;

      case 'deleteArticlePlace':
        this.articlePlaceService.delete(this.data.id!).subscribe({
          next: () => { this.dialogRef.close(true); }
        });
        break;

      default:
        break;
    }
  }

}
